import { RowNode } from 'ag-grid-community'

export default {
  data() {
    return {
      agValue: undefined,
      nextAgValue: undefined
    }
  },
  watch: {
    agValue() {
      this.nextAgValue = this.agValue
    }
  },
  created() {
    const { node } = this.params

    node.addEventListener(RowNode.EVENT_DATA_CHANGED, this.rowDataChange)

    node.addEventListener(RowNode.EVENT_CELL_CHANGED, this.cellChange)
  },
  beforeDestroy() {
    const { node } = this.params

    node.removeEventListener(RowNode.EVENT_DATA_CHANGED, this.rowDataChange)

    node.removeEventListener(RowNode.EVENT_CELL_CHANGED, this.cellChange)
  },
  methods: {
    // 供ag-grid调用，获取最后value
    getValue() {
      return this.nextAgValue
    },
    rowDataChange({ newData }) {
      const { column } = this.params
      const { colId } = column
      this.agValue = newData[colId]
    },
    cellChange({ newValue, column }) {
      if (column.colId === this.params.column.colId) {
        this.agValue = newValue
      }
    },
    triggerBlur(e) {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { blur } = cellEditorComponentProps || {}

      blur?.({
        event: e,
        agParams: restAgParams
      })
    },
    triggerFocus(e) {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { focus } = cellEditorComponentProps || {}

      focus?.({
        event: e,
        agParams: restAgParams
      })
    },
    triggerKeyup(e) {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { keyup } = cellEditorComponentProps || {}

      keyup?.({
        event: e,
        agParams: restAgParams
      })
    },
    triggerKeydown(e) {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}
      const { keydown } = cellEditorComponentProps || {}
      keydown?.({
        event: e,
        agParams: restAgParams
      })
    }
  }
}
